import React, { useEffect, useState, useRef } from 'react';

function PdfViewerModal() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfTitle, setPdfTitle] = useState('Relatório');
  const pdfBlobRef = useRef(null);

  const isAndroid = () => {
    return /android|webos|iphone|ipad|ipot|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase()
    );
  };

  const printDirectly = (url) => {
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
        setTimeout(() => {
          printWindow.close();
        }, 1000);
      };
    }
  };

  const loadPdfData = () => {
    const pdfData = sessionStorage.getItem('pdfViewerData');
    if (pdfData) {
      try {
        const parsedData = JSON.parse(pdfData);
        const { url, title, pdfId } = parsedData;

        if (pdfId && window.pdfStorage && window.pdfStorage[pdfId]) {
          // blob exists
        }

        setPdfUrl(url);
        setPdfTitle(title || 'Relatório');

        if (isAndroid()) {
          setTimeout(() => {
            printDirectly(url);
          }, 100);
        }
      } catch (error) {
        console.error('Erro ao recuperar dados do PDF:', error);
      }
    }
  };

  useEffect(() => {
    let hasLoaded = false;

    const handleLoad = () => {
      if (!hasLoaded) {
        hasLoaded = true;
        loadPdfData();
      }
    };

    handleLoad();

    const handlePdfUpdate = () => {
      hasLoaded = false;
      loadPdfData();
    };

    window.addEventListener('pdfViewerUpdate', handlePdfUpdate, true);

    const fallbackInterval = setInterval(() => {
      loadPdfData();
    }, 200);

    const timeoutHandle = setTimeout(() => {
      clearInterval(fallbackInterval);
    }, 5000);

    return () => {
      window.removeEventListener('pdfViewerUpdate', handlePdfUpdate, true);
      clearInterval(fallbackInterval);
      clearTimeout(timeoutHandle);
    };
  }, []);

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${pdfTitle || 'relatorio'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handlePrint = () => {
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl);
      if (printWindow) {
        printWindow.print();
      }
    }
  };

  const handleClose = () => {
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl);
    }
    pdfBlobRef.current = null;
    sessionStorage.removeItem('pdfViewerData');
    setPdfUrl(null);
    setPdfTitle('Relatório');
  };

  if (!pdfUrl) {
    return null;
  }

  if (isAndroid()) {
    return null;
  }

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg" style={{ maxWidth: '95vw', height: '90vh' }}>
        <div className="modal-content h-100 overflow-hidden">
          <div
            className="modal-header text-white"
            style={{
              background: 'linear-gradient(45deg, rgb(30,27,75) 0%, rgb(55,48,163) 100%)',
              padding: '0.35rem 1rem',
              borderTopLeftRadius: '0.5rem',
              borderTopRightRadius: '0.5rem',
              border: 'none',
            }}
          >
            <div className="d-flex align-items-center flex-grow-1">
              <i className="bi bi-file-earmark-pdf me-2"></i>
              <h6 className="m-0 flex-grow-1">
                {pdfTitle || 'Visualizador de Relatório'}
              </h6>
            </div>
            <button
              className="btn btn-sm text-white me-2"
              onClick={handleDownload}
              title="Baixar PDF"
              style={{ border: 'none', background: 'transparent' }}
            >
              <i className="bi bi-download"></i>
            </button>
            <button
              className="btn btn-sm text-white me-2"
              onClick={handlePrint}
              title="Imprimir"
              style={{ border: 'none', background: 'transparent' }}
            >
              <i className="bi bi-printer"></i>
            </button>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
              title="Fechar"
            ></button>
          </div>
          <div className="modal-body p-0" style={{ flex: 1, overflow: 'hidden' }}>
            <iframe
              key={pdfUrl}
              src={pdfUrl}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="PDF Viewer"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PdfViewerModal;
